export default __webpack_public_path__ + "static/media/Path510@2x.7211d600.png";